import { tv } from 'tailwind-variants';

export const styles = tv({
  slots: {
    base: 'flex items-start gap-4',
    imageWrapper: 'relative size-15 shrink-0 sm:size-25 md:size-20',
    image: 'object-cover',
    info: 'flex flex-col gap-2.5 sm:gap-3',
    title: 'heading-xs md:heading-s sm:heading-m !font-[450]',
    description: 'text-[12px]',
    tags: 'flex h-6 gap-1',
    tag: 'heading-xs rounded-full px-2 py-0.5'
  },
  variants: {
    color: {
      primary: {
        base: 'bg-white',
        tag: 'bg-bg-items-white'
      },
      secondary: {
        base: 'bg-bg-items-white',
        tag: 'bg-white'
      }
    }
  }
});
